export const PAYMENT_MODES = ["Cash", "UPI", "Bank Transfer", "Credit Card", "Debit Card", "Cheque", "Other"];
export const PAYMENT_STATUSES = ["Paid", "Partial", "Pending", "Overdue", "Refunded"];

export const PAY_STATUS_STYLE = {
  Paid: "bg-accent/15 text-green-700",
  Partial: "bg-amber-100 text-amber-700",
  Pending: "bg-slate-100 text-slate-600",
  Overdue: "bg-rose-100 text-rose-700",
  Refunded: "bg-violet-100 text-violet-700",
};

export const REPORT_TYPES = [
  { value: "daily", label: "Daily Collection" },
  { value: "monthly", label: "Monthly Collection" },
  { value: "yearly", label: "Yearly Collection" },
  { value: "pending", label: "Pending Report" },
  { value: "overdue", label: "Overdue Report" },
  { value: "by_executive", label: "Collection by Sales Executive" },
  { value: "by_course", label: "Collection by Course" },
  { value: "by_batch", label: "Collection by Batch" },
];

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
